// src/api/redesSociales.js
import api from "./config.js";

// Obtener todas las redes sociales
export const getRedesSociales = async () => {
    const { data } = await api.get("/redes-sociales");
    return Array.isArray(data) ? data : data.redesSociales || [];
};

// Obtener una red social por ID
export const getRedSocial = async (id) => {
    const { data } = await api.get(`/redes-sociales/${id}`);
    return data;
};

// Crear una nueva red social
export const createRedSocial = async (redSocial) => {
    const { data } = await api.post("/redes-sociales", redSocial);
    return data;
};

// Actualizar red social
export const updateRedSocial = async (id, redSocial) => {
    const { data } = await api.put(`/redes-sociales/${id}`, redSocial);
    return data;
};

// Eliminar red social
export const deleteRedSocial = async (id) => {
    const { data } = await api.delete(`/redes-sociales/${id}`);
    return data;
};
